(function () {
  const API_URL = 'https://6eki2htjre.execute-api.us-east-1.amazonaws.com/Stage/yarbo/market/klaviyoSubscribe';
  const SHOPIFY_SUBSCRIBE_URL = '/apps/report/front/customer/subscribe';
  const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const SHOPIFY_RETRY_MESSAGE = 'Subscription failed. Please try again.';

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find((row) => row.startsWith(`${name}=`));
    return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
  }

  function buildPayload({ email, phone, emailType, listId }) {
    const mUtm = JSON.parse(getCookie('m_utm') || '{}');

    return {
      email,
      name: '',
      phone: phone || '',
      subscribeEmailType: emailType || 'stay_connected',
      klaviyo_list_id: listId || '',
      updateDate: new Date().toISOString(),
      pathname: location.href,
      userId: mUtm.user_id,
      clarityId: '',
      deviceType: mUtm.os,
      country: 'US',
      state: mUtm['region-name'],
      city: mUtm.ud_city,
      utmSource: mUtm.utm_source,
      utmMedium: mUtm.utm_medium,
      utmCampaign: mUtm.utm_campaign,
    };
  }

  async function postSubscribe(payload) {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();
    let result;

    try {
      result = JSON.parse(responseText);
    } catch (error) {
      throw new Error('Invalid response format');
    }

    if (!response.ok || !result || result.success === false) {
      throw new Error(result?.message || 'Subscription failed. Please try again.');
    }

    return result;
  }


  function parseCustomerTags(root) {
    return (root.dataset.customerTags || '')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
  }

  async function postShopifySubscribe(email, tags) {
    let result;

    try {
      const response = await fetch(SHOPIFY_SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, tags }),
      });
      result = await response.json();
    } catch (error) {
      throw new Error(SHOPIFY_RETRY_MESSAGE);
    }

    if (!result || result.code !== 200) {
      throw new Error(SHOPIFY_RETRY_MESSAGE);
    }

    return result;
  }

  function parseListIds(root) {
    const primary = (root.dataset.klaviyoListId || '').trim();
    const additional = (root.dataset.additionalKlaviyoListIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id && id !== primary);

    return { primary, additional };
  }

  function trackLead({ email, phone }) {
    try {
      if (window.klaviyo) {
        window.klaviyo.push([
          'identify',
          {
            email,
            phone_number: phone,
          },
        ]);
      }

      if (window.reportEvent) {
        window.reportEvent({
          event: 'lead_form_submit',
          email,
          phone_number: phone,
        });
      }
    } catch (error) {
      console.error('Stay connected subscribe tracking error:', error);
    }
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.classList.toggle('hidden', hidden);
  }

  function initForm(root) {
    const form = root.querySelector('.stay-connected-subscribe-form');
    if (!form || form.dataset.bound === 'true') return;

    form.dataset.bound = 'true';

    const emailInput = form.querySelector('.stay-connected-subscribe-email');
    const phoneInput = form.querySelector('.stay-connected-subscribe-phone');
    const privacyCheckbox = form.querySelector('.stay-connected-subscribe-privacy');
    const submitBtn = form.querySelector('.stay-connected-subscribe-submit');
    const submitText = form.querySelector('.stay-connected-subscribe-submit-text');
    const submitSpinner = form.querySelector('.stay-connected-subscribe-spinner');
    const errorEl = form.querySelector('.stay-connected-subscribe-error');
    const successEl = root.querySelector('.stay-connected-subscribe-success');

    const formCard = root.closest('.stay-connected-form-card');

    const messages = {
      email: root.dataset.errorEmail || 'Please enter a valid email address.',
      privacy: root.dataset.errorPrivacy || 'Please tick the agreements!',
      network: root.dataset.errorNetwork || 'Network error. Please try again.',
    };

    function setError(message) {
      if (errorEl) {
        errorEl.textContent = message || '';
        setHidden(errorEl, !message);
      }
      setHidden(successEl, true);
      setHidden(form, false);
      formCard?.classList.remove('is-success');
    }

    function setSuccess() {
      if (errorEl) {
        errorEl.textContent = '';
        setHidden(errorEl, true);
      }
      setHidden(form, true);
      setHidden(successEl, false);
      formCard?.classList.add('is-success');
    }

    function setLoading(loading) {
      submitBtn.disabled = loading;
      submitBtn.classList.toggle('is-loading', loading);
      submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      setHidden(submitText, loading);
      setHidden(submitSpinner, !loading);
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      setError('');

      const email = emailInput.value.trim();
      const phone = phoneInput ? phoneInput.value.trim() : '';

      if (!EMAIL_RE.test(email)) {
        setError(messages.email);
        emailInput.focus();
        return;
      }

      if (privacyCheckbox && !privacyCheckbox.checked) {
        setError(messages.privacy);
        privacyCheckbox.focus();
        return;
      }

      const emailType = root.dataset.emailType || 'stay_connected';
      const { primary, additional } = parseListIds(root);
      const listIds = [primary, ...additional].filter(Boolean);

      if (!listIds.length) {
        setError('Klaviyo list ID is not configured.');
        return;
      }

      setLoading(true);

      try {
        await postSubscribe(buildPayload({ email, phone, emailType, listId: listIds[0] }));

        if (listIds.length > 1) {
          await Promise.allSettled(
            listIds.slice(1).map((listId) => postSubscribe(buildPayload({ email, phone, emailType, listId })))
          );
        }

        const customerTags = parseCustomerTags(root);
        if (customerTags.length) {
          await postShopifySubscribe(email, customerTags);
        }

        trackLead({ email, phone });
        setSuccess();
      } catch (error) {
        setError(error instanceof Error && error.message ? error.message : messages.network);
      } finally {
        setLoading(false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-stay-connected-subscribe]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
